<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
    <delete-popup
      :deletePopup="deleteAutomationPopup"
      title="Automation Step"
      @deletePressed="deleteScenario(delId)"
      @cancelPressed="deleteAutomationPopup = false"
    >
    </delete-popup>
    <div class="w-full">
      <vx-card>
        <div class="w-full">
          <vs-table :data="automationStepList">
            <template slot="header">
              <router-link
                :to="{ path: '/setup/automation-master' }"
                class="mt-2"
              >
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </router-link>
              <div class="list-heading">
                {{ $t("setup.label.automation_steps") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button @click="automationStepPopup = true" size="small">{{
                  $t("setup.label.add_automation_step")
                }}</vs-button>
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.Id") }}</vs-th>
              <vs-th>{{ $t("setup.label.StepOrder") }}</vs-th>
              <vs-th>{{ $t("setup.label.ActionType") }}</vs-th>
              <vs-th>{{ $t("setup.label.ActionDetails") }}</vs-th>
              <vs-th>{{ $t("setup.label.action_name") }}</vs-th>

              <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="index" :data="item" v-for="(item, index) in data">
                <vs-td :data="item">{{ item.id }}</vs-td>
                <vs-td :data="item">{{ item.stepOrder }}</vs-td>
                <vs-td :data="item">{{ item.actionType }}</vs-td>
                <vs-td :data="item">{{ item.actionDetails }}</vs-td>
                <vs-td :data="item">{{ item.actionName }}</vs-td>

                <vs-td class="whitespace-no-wrap" :data="item">
                  <div class="container_img">
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="setScenarioData(item)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                      color="danger"
                      :title="$t('setup.label.Delete')"
                      type="border"
                      size="small"
                      @click="
                        delId = item.id;
                        deleteAutomationPopup = true;
                      "
                      class="icon_row"
                    ></feather-icon></div
                ></vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
      <div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="
              isEdit
                ? $t('setup.label.EditAutomationStep')
                : $t('setup.label.add_automation_step')
            "
            :active.sync="automationStepPopup"
            class="popup-close"
          >
            <form>
              <div class="vx-row">
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <vs-input
                    :label="$t('setup.label.ActionType')"
                    class="w-full mb-2 font-semibold"
                    v-model="actionType"
                  />
                </div>
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <vs-input
                    :label="$t('setup.label.ActionDetails')"
                    class="w-full mb-2 font-semibold"
                    v-model="actionDetails"
                  />
                </div>
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <vs-input
                    :label="$t('setup.label.action_name')"
                    class="w-full mb-2 font-semibold"
                    v-model="actionName"
                  />
                </div>
              </div>
              <div class="vx-row center my-4">
                <div class="vx-col w-full">
                  <vs-button
                    color="primary"
                    class="footerButton-next mb-5"
                    @click="onSubmit"
                    >{{ $t("setup.label.Submit") }}</vs-button
                  >
                </div>
              </div>
            </form>
          </vs-popup>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import DeletePopup from "@/components/DeletePopup.vue";
import vSelect from "vue-select";

export default {
  data() {
    return {
      loading: false,
      descriptionItems: [5, 10, 15],
      automationStepPopup: false,
      deleteAutomationPopup: false,
      delId: 0,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      isEdit: false,
      actionType: "",
      actionDetails: "",
      actionName: "",
      stepId: "",
    };
  },
  components: {
    AtomSpinner,
    "delete-popup": DeletePopup,
    "v-select": vSelect,
    Datepicker,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      collectionTriggers: (state) => state.collectionProfile.collectionTriggers,
      automationStepList: (state) => state.automationMaster.automationStepList,
      collectionActions: (state) => state.collectionProfile.collectionActions,
    }),
    sortedCollectionScenerios() {
      return [...this.collectionScenerios].sort(
        (a, b) => a.scenarioId - b.scenarioId
      );
    },
  },
  methods: {
    setScenarioData(item) {
      this.stepId = item.id;
      this.actionType = item.actionType;
      this.actionDetails = item.actionDetails;
      this.actionName = item.actionName;
      this.isEdit = true;
      this.automationStepPopup = true;
    },
    async deleteScenario(id) {
      try {
        await this.$store.dispatch(
          "automationMaster/deleteAutomationStepAction",
          id
        );
        this.$store.dispatch(
          "automationMaster/getAutomationStepAction",
          this.$route.params.id
        );
        this.deleteAutomationPopup = false;
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    async onSubmit() {
      let payload = {
        automationId: this.$route.params.id,
        actionType: this.actionType,
        actionDetails: this.actionDetails,
        actionName: this.actionName,
      };
      try {
        if (!this.isEdit)
          await this.$store.dispatch(
            "automationMaster/createAutomationStepAction",
            payload
          );
        else
          await this.$store.dispatch(
            "automationMaster/updateAutomationStepAction",
            { id: this.stepId, data: payload }
          );
        this.automationStepPopup = false;
        this.actionType = "";
        this.actionDetails = "";
        this.actionName = "";
        this.$store.dispatch(
          "automationMaster/getAutomationStepAction",
          this.$route.params.id
        );
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
  },
  watch: {
    automationStepPopup(val) {
      if (!val) {
        this.actionType = "";
        this.actionDetails = "";
        this.actionName = "";
      }
    },
  },
  mounted() {
    this.$store.dispatch(
      "automationMaster/getAutomationStepAction",
      this.$route.params.id
    );
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 100%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
